import {isEmpty} from 'lodash'
import React from 'react'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import A1_CONSTANTS from '../../core/_const'
import {ModalTemplate} from '../template'

type Props = {
  show: boolean
  data?: {payload: any}
  handleClose: () => void
  handleChooseOption: (
    type: string,
    has_batch: (string | number)[],
    no_batch: (string | number)[]
  ) => void
}

const SmartA1BatchDuplicateModal: React.FC<Props> = ({
  show,
  data,
  handleClose,
  handleChooseOption,
}) => {
  const intl = useIntl()

  const handleSubmit = async (type: string) => {
    if (
      type === A1_CONSTANTS.STATUS_ADD_TO_A1_BATCH.ACTION.EXCLUDE &&
      isEmpty(data?.payload?.no_batch)
    ) {
      toast.warning(intl.formatMessage({id: 'NO_ORDERS_TO_ADD_TO_A1_BATCH'}))
      handleClose()
      return
    }
    handleChooseOption(type, data?.payload?.has_batch || [], data?.payload?.no_batch || [])
  }

  return (
    <ModalTemplate
      id='gori_modal_smart-a1_batch_duplicated'
      show={show}
      handleClose={handleClose}
      dialogClassName='modal-size-md h-auto'
      contentClassName='modal-padding'
      title={'MOVE_ORDERS_TO_SMART_A1_BATCH'}
      bodyClassName='vh-75 overflow-auto'
      titlePrimaryBtn='MOVING'
      titleSecondaryBtn='EXCLUDING'
      onClickPrimaryBtn={() => handleSubmit('move')}
      onClickSecondaryBtn={() => handleSubmit('exclude')}
      secondaryBtnWithClose={false}
    >
      <div className='row my-10'>
        <div className='fs-3 mb-1'>
          <span className='fw-bolder'>
            {data?.payload?.has_batch?.length} {intl.formatMessage({id: 'ORDERS'})}
          </span>{' '}
          {intl.formatMessage({id: 'ARE_ALREADY_IN_A_DIFFERENT_A1_BATCH'})}.
        </div>

        <div className='fs-3 flex-wrap'>
          {intl.formatMessage(
            {
              id: 'ARE_YOU_SURE_YOU_WANT_TO_MOVE_THEM_TO_NEW_SMART_A1_BATCH',
            },
            {
              strong: (chunks) => <strong>{chunks}</strong>,
            }
          )}
        </div>
      </div>
    </ModalTemplate>
  )
}

export {SmartA1BatchDuplicateModal}
